import { render, staticRenderFns } from "./RequestFormExterno.vue?vue&type=template&id=488b1033&"
import script from "./RequestFormExterno.vue?vue&type=script&lang=ts&"
export * from "./RequestFormExterno.vue?vue&type=script&lang=ts&"
import style0 from "./RequestFormExterno.vue?vue&type=style&index=0&id=488b1033&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports